export default __webpack_public_path__ + "media/images/theme/m_logo_dark-8c21d833d5be8814aa846578c792b088.png";